import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { HeatmapLayer } from '@deck.gl/aggregation-layers';

const HEATMAP_COLOR_RANGE = [
    [255, 255, 0, 0],
    [255, 220, 0, 128],
    [255, 180, 0, 179],
    [255, 120, 0, 217],
    [255, 60, 0, 230],
    [230, 20, 0, 242],
    [180, 0, 0, 255],
    [120, 0, 0, 255],
];

export const buildComplaintHeatmapPoints = (complaints = []) =>
    complaints
        .filter((complaint) => {
            const lat = parseFloat(
                complaint?.Latitude ?? complaint?.latitude ?? complaint?.Lat ?? complaint?.lat
            );
            const lng = parseFloat(
                complaint?.Longitude ??
                    complaint?.longitude ??
                    complaint?.Long ??
                    complaint?.lng ??
                    complaint?.Lng
            );
            const status = complaint?.Status ?? complaint?.status ?? '';
            return (
                Number.isFinite(lat) &&
                Number.isFinite(lng) &&
                !(lat === 0 && lng === 0) &&
                (status === 'Pending' || status === 'Allocated')
            );
        })
        .map((complaint) => {
            const lat = parseFloat(
                complaint.Latitude ?? complaint.latitude ?? complaint.Lat ?? complaint.lat
            );
            const lng = parseFloat(
                complaint.Longitude ??
                    complaint.longitude ??
                    complaint.Long ??
                    complaint.lng ??
                    complaint.Lng
            );
            const status = complaint.Status ?? complaint.status ?? '';
            return {
                position: [lng, lat],
                weight: status === 'Pending' ? 2 : 1,
            };
        })
        .filter(
            (point) =>
                Number.isFinite(point.position[0]) && Number.isFinite(point.position[1])
        );

const createHeatmapLayer = (data, opacity = 1) =>
    new HeatmapLayer({
        id: 'complaint-heatmap-layer',
        data,
        getPosition: (point) => point.position,
        getWeight: (point) => point.weight,
        radiusPixels: 35,
        opacity,
        colorRange: HEATMAP_COLOR_RANGE,
        threshold: 0.03,
        intensity: 1,
    });

export const createComplaintHeatmapOverlay = (map, complaints = [], opacity = 1) => {
    const data = buildComplaintHeatmapPoints(complaints);
    if (!map || data.length === 0) return null;

    const overlay = new GoogleMapsOverlay({
        layers: [createHeatmapLayer(data, opacity)],
    });
    overlay.setMap(map);
    overlay.__heatmapData = data;
    return overlay;
};

export const updateComplaintHeatmapOpacity = (overlay, opacity) => {
    if (!overlay?.__heatmapData?.length) return;

    overlay.setProps({
        layers: [createHeatmapLayer(overlay.__heatmapData, opacity)],
    });
};

export const clearComplaintHeatmapOverlay = (overlay) => {
    if (!overlay) return;

    try {
        overlay.setMap(null);
    } catch (error) {
        // Ignore cleanup errors during map teardown.
    }

    try {
        overlay.finalize?.();
    } catch (error) {
        // Ignore cleanup errors during map teardown.
    }
};
